import axios from 'axios';
import store from '@/store';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_AUTHENTICATION_URL = process.env.VUE_APP_API_URL+"/authentication";
const ACCESS_TOKEN_NAME_IN_STORAGE = process.env.VUE_APP_ACCESS_TOKEN_NAME_IN_STORAGE;

export default class AuthenticationController {
    static async login(username, password) {
        // Validate input 
        if (!username || !username.trim() || !password || !password.trim()) {
            const error = new Error('Please enter both username and password.');
            error.response = { data: { detail: 'Please enter both username and password.' } };
            throw error;
        }
        
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        
        const response = await axios.post(`${API_AUTHENTICATION_URL}/login`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        const { access_token } = response.data;
        localStorage.setItem(ACCESS_TOKEN_NAME_IN_STORAGE, access_token);
        await store.dispatch('fetchUser');
        return response.data;
    }
    
    static async logout() {
        localStorage.removeItem(ACCESS_TOKEN_NAME_IN_STORAGE);
        store.commit('clearUser');
    }

    static getToken() {
        return localStorage.getItem(ACCESS_TOKEN_NAME_IN_STORAGE);
    }
}

applyErrorHandlers(AuthenticationController);
